import { render } from "./Headquarters.vue?vue&type=template&id=03627da6&ts=true"
import script from "./Headquarters.vue?vue&type=script&lang=ts"
export * from "./Headquarters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__